import styled, { css } from 'styled-components';

export const WrapperTablePlan = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    padding: 0 0 48px;
    position: relative;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0 20px 48px;
    }
  `}
`;

export const TablePlan = styled.div`
  ${({ theme }) => css`
    display: flex;
    overflow: hidden;
    padding-top: 51px;
    width: 100%;
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 24px;
      padding-top: 0;
    }
  `}
`;

export const TableColumn = styled.div`
  ${({ theme, type, plan }) => css`
    position: relative;
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      ${type === 'desc' && css`
        order: 1;
      `}

      ${plan === 'pro' && css`
        order: 2;
      `}

      ${plan === 'free' && css`
        border: 1px solid ${theme.v2.colors.neutral.highMedium};
        border-radius: 16px;
        order: 3;
      `}
    }
    
    ${type === 'desc' && css`
      @media (min-width: ${theme.v2.breakpoints.md}) {
        width: 32%;
      }
    `}

    ${type === 'plan' && css`
      overflow: hidden;

      @media (min-width: ${theme.v2.breakpoints.md}) {
        width: 27%;
      }
    `}

    ${plan === 'pro' && css`
      background: ${theme.v2.colors.gradient.secondary};
      border-radius: 16px;
      padding: 52px 2px 2px;
      
      @media (min-width: ${theme.v2.breakpoints.md}) {
        margin-top: -52px;
      }
    `}
  `}
`;

export const TableInnerColumn = styled.div`
  ${({ theme, plan }) => css`
    background-color: ${theme.v2.colors.white.primary};

    ${plan === 'pro' && css`
      border-radius: 0 0 14px 14px;
      overflow: hidden;
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding-bottom: 24px;
    }
  `}
`;

export const HeaderPlan = styled.div`
  ${({ theme, plan, type }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 14px 14px 0 0;
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 24px 20px;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      min-height: 234px;
    }

    ${plan === 'pro' && css`
      border-radius: 0;
    `}
    
    ${type === 'desc' && css`
      background-color: ${theme.v2.colors.brand.primaryUltraLight};
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    `}

    ${plan === 'free' && css`
      @media (min-width: ${theme.v2.breakpoints.md}) {
        border: 1px solid ${theme.v2.colors.neutral.highMedium};
        border-radius: 16px;
      }
    `}
  `}
`;

export const WrapperSnappyImage = styled.div`
  height: 49px;
  left: 29px;
  position: absolute;
  top: -45px;
  width: 102px;
`;

export const SnappyImage = styled.img``;

export const TitleHeaderDesc = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.4;
  `}
`;

export const SubtitleHeaderDesc = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;
    
    @media (min-width: ${theme.v2.breakpoints.lg}) {
      max-width: 260px;
    }
  `}
`;

export const WrapperPlanRecurrence = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const TitlePlanRecurrence = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
  `}
`;

export const PlanRecurrence = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    padding: 8px 16px;
  `}
`;

export const HeaderPlanPro = styled.div`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.white.primary};
    display: flex;
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 4px;
    justify-content: center;
    left: 0;
    padding: 15px;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2px
  `}
`;

export const PlanTitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    margin-bottom: 5px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const WrapperPlanPrice = styled.div`
  align-items: baseline;
  display: flex;
  gap: 4px;
`;

export const PlanPrice = styled.div`
  ${({ theme }) => css`
    font-size: 32px;
    font-weight: ${theme.v2.font.weights.bold};
  `}
`;

export const PlanCurrency = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
  `}
`;

export const PlanPriceRecurrence = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
  `}
`;

export const PlanPriceDesc = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    margin-top: 8px;
  `}
`;

export const WrapperPlanButton = styled.div`
  margin-top: 32px;
`;

export const TablePlanLine = styled.div`
  ${({ theme, type }) => css`
    align-items: center;
    display: flex;
    justify-content: ${type === 'desc' ? 'flex-start' : 'center'};
    padding: 0 16px;
    position: relative;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      min-height: 80px;
      padding: 16px 24px;

      &:nth-child(even) {
        background: ${theme.v2.colors.neutral.highLight};
      }

      ${type === 'desc' && css`
        &:nth-child(even) {
          &:before {
            background: ${theme.v2.colors.neutral.highLight};
            bottom: 0;
            content: "";
            left: 0;
            position: absolute;
            top: 0;
            z-index: 0;
            width: 100vw;
          }
        }
      `}
    }
  `}
`;

export const TableSpacing = styled.div`
  width: 32px;
`;

export const DescText = styled.div`
  ${({ theme, type, lineCount }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 20px;
    position: relative;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      display: flex;
      text-align: ${type === 'plan' ? 'center' : 'left'};

      ${lineCount !== 0 && css`
        min-height: ${lineCount * 20}px;
      `}
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      padding-left: 24px;
      width: 100%;

      svg {
        height: 16px;
        left: 0;
        position: absolute;
        top: 2px;
        width: 16px;
      }
    }
  `}
`;
